import { useState, useEffect, useCallback } from 'react';
import { useAssistantActions, useAssistantIntents } from './useLottoAssistantContext';

export const useTicketStateManagement = ({ initialTickets, messageId }) => {
  const { removeBetTicketById, removeMessageById } = useAssistantActions();
  const { stageTickets } = useAssistantIntents();
  const [ticketStates, setTicketStates] = useState(initialTickets);

  const validTickets = ticketStates.filter((t) => t !== null);

  useEffect(() => {
    stageTickets(validTickets);
  }, [ticketStates, stageTickets]);

  const handleTicketUpdate = useCallback((index, ticket) => {
    setTicketStates((prev) => {
      const next = [...prev];
      next[index] = ticket;
      return next;
    });
  }, []);

  const handleTicketRemove = useCallback(
    (ticketId) => {
      const ticketIndex = ticketStates.findIndex((t) => t?.ticket_id === ticketId);
      if (ticketIndex === -1) return;

      const remaining = ticketStates.filter((t) => t?.ticket_id !== ticketId);
      setTicketStates(remaining);

      if (remaining.length === 0) {
        removeMessageById(messageId);
      } else {
        removeBetTicketById(messageId, ticketIndex);
      }
    },
    [messageId, ticketStates, removeBetTicketById, removeMessageById]
  );

  return {
    ticketStates,
    validTickets,
    handleTicketUpdate,
    handleTicketRemove,
    setTicketStates,
  };
};
